/* Omaggio alberi di Natale EDG — Prestige Home
 *
 * Due compiti distinti:
 * 1. il BOX sotto il prezzo, solo sulle schede abilitate (CFG.attivo)
 * 2. la MANUTENZIONE del carrello, ovunque: allinea le quantità degli omaggi a
 *    quelle degli alberi e toglie quelli rimasti senza il loro albero
 *
 * Tre opzioni, sempre una sola attiva. Le palline sono preselezionate, e chi non
 * vuole nulla lo dice con la terza casella: così "nessuna spunta" non esiste come
 * stato ambiguo. Cliccare sull'opzione già attiva non la libera, la conferma.
 *
 * Un omaggio per ogni albero: tre alberi uguali fanno tre omaggi, due modelli
 * diversi ne fanno due. La quantità viene riallineata a ogni modifica del carrello.
 *
 * La miniatura c'è solo sulle palline. Sul prodotto a scelta no, di proposito:
 * una foto singola farebbe pensare a un omaggio già deciso.
 *
 * La scelta non viene scritta come proprietà sull'albero: l'unica fonte di verità è
 * la riga omaggio nel carrello, che porta con sé tutto. Una sola fonte, nessun
 * rischio che albero e omaggio si contraddicano se il cliente cancella la riga.
 *
 * Non intercetta l'invio del form: annota la scelta e aggiunge la riga quando il
 * tema conferma che l'albero è entrato nel carrello. Così non litiga con
 * l'interceptor della confezione regalo, che invece il form lo trattiene.
 */
(function () {
  'use strict';

  var CFG = window.omaggioConfig;
  if (!CFG || !CFG.varianti) return;

  var PALLINE = Number(CFG.varianti.palline);
  var SCELTA = Number(CFG.varianti.scelta);
  if (!PALLINE || !SCELTA) return;

  var PREDEFINITA = 'palline';

  var scelta = PREDEFINITA;
  var testi = { palline: '', scelta: '' };
  var inAttesa = null;
  var occupato = false;

  var ICONA_REGALO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var ICONA_SPUNTA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function conOmaggio() {
    return scelta === 'palline' || scelta === 'scelta';
  }

  /* ------------------------------------------------------------------ utils */

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      cartJs: (r.cart || '/cart') + '.js',
      add: r.cartAdd || '/cart/add.js',
      change: r.cartChange || '/cart/change.js'
    };
  }

  async function getCart() {
    var res = await fetch(routes().cartJs, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.description || data.message || url + ' ' + res.status);
    return data;
  }

  async function ridisegnaCarrello() {
    var el = document.querySelector('.cc-main-cart cart-items') || document.querySelector('cart-items');
    if (el && typeof el.refresh === 'function') {
      try { await el.refresh(); } catch (e) { /* non bloccante */ }
    }
  }

  /* -------------------------------------------------------------- il box */

  function opzioneHTML(id, nome, nota, valore, segnaposto, semplice, immagine) {
    return '<label class="omaggio__opt' + (semplice ? ' omaggio__opt--plain' : '') + '" data-opt="' + id + '">' +
             '<span class="omaggio__row">' +
               '<input type="checkbox" class="omaggio__input js-omaggio-opt" value="' + id + '">' +
               '<span class="omaggio__box">' + ICONA_SPUNTA + '</span>' +
               (immagine
                 ? '<img class="omaggio__thumb" src="' + immagine + '" alt="" width="52" height="52" loading="lazy">'
                 : '') +
               '<span class="omaggio__text">' +
                 '<span class="omaggio__name">' + nome + '</span>' +
                 (valore
                   ? '<span class="omaggio__value">' +
                       '<span class="omaggio__was">' + valore + '</span>' +
                       '<span class="omaggio__free">in regalo</span>' +
                     '</span>'
                   : '') +
                 (nota ? '<span class="omaggio__note">' + nota + '</span>' : '') +
               '</span>' +
             '</span>' +
             (segnaposto
               ? '<span class="omaggio__field" hidden>' +
                   '<input type="text" class="js-omaggio-testo" data-opt="' + id + '" maxlength="120" ' +
                   'autocomplete="off" placeholder="' + segnaposto + '">' +
                 '</span>'
               : '') +
           '</label>';
  }

  function creaBox() {
    var box = document.createElement('div');
    box.className = 'omaggio';
    box.innerHTML =
      '<div class="omaggio__head">' + ICONA_REGALO +
        '<span class="omaggio__eyebrow">In regalo con questo albero</span>' +
      '</div>' +
      '<p class="omaggio__title">Scegli il tuo omaggio da ' + CFG.valore + '</p>' +
      '<p class="omaggio__note">Un omaggio per ogni albero acquistato.</p>' +
      '<div class="omaggio__list">' +
        opzioneHTML('palline', 'Palline in vetro premium', '', CFG.valore,
                    'Modello preferito — lascia vuoto e scegliamo noi', false, CFG.immaginePalline) +
        opzioneHTML('scelta', 'Un altro prodotto a tua scelta', 'Dal nostro catalogo, dello stesso valore.', CFG.valore,
                    'Inserisci il codice o il titolo del prodotto che desideri', false, null) +
        opzioneHTML('nessuno', 'Non desidero l’omaggio', '', null, null, true, null) +
      '</div>' +
      '<p class="omaggio__confirm">' + ICONA_SPUNTA +
        '<span>Lo aggiungiamo al carrello insieme all’albero.</span>' +
      '</p>';
    return box;
  }

  /* Il blocco prezzo, saltando i blocchi delle app che gli stanno attaccati
     (per esempio l'avviso del prezzo più basso negli ultimi 30 giorni, che per
     legge deve restare accanto al prezzo). */
  function trovaAncora() {
    var blocchi = [].slice.call(document.querySelectorAll('.product-info__block'));
    var prezzo = null;

    for (var i = 0; i < blocchi.length; i += 1) {
      if (blocchi[i].querySelector('.price__current') && !blocchi[i].querySelector('[name="add"]')) {
        prezzo = blocchi[i];
        break;
      }
    }
    if (!prezzo) return null;

    var ancora = prezzo;
    var dopo = ancora.nextElementSibling;
    while (dopo && dopo.classList && dopo.classList.contains('product-info__block') &&
           dopo.querySelector('[id^="shopify-block"]')) {
      ancora = dopo;
      dopo = ancora.nextElementSibling;
    }
    return ancora;
  }

  function monta() {
    if (!CFG.attivo) return;
    if (document.querySelector('.omaggio')) return;
    var ancora = trovaAncora();
    if (!ancora) return;
    ancora.insertAdjacentElement('afterend', creaBox());
    applicaStato();
  }

  function applicaStato() {
    var box = document.querySelector('.omaggio');
    if (!box) return;

    box.classList.toggle('is-active', conOmaggio());

    box.querySelectorAll('.omaggio__opt').forEach(function (opt) {
      var id = opt.dataset.opt;
      var mio = id === scelta;

      opt.querySelector('.js-omaggio-opt').checked = mio;
      opt.classList.toggle('is-selected', mio);

      var campo = opt.querySelector('.omaggio__field');
      if (!campo) return;
      campo.hidden = !mio;

      var input = campo.querySelector('.js-omaggio-testo');
      if (input && input.value !== testi[id]) input.value = testi[id];
    });
  }

  /* ---------------------------------------------------------------- eventi */

  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('.js-omaggio-opt')) return;

    // Sempre una sola attiva: ricliccare quella scelta non la libera.
    scelta = t.value;
    applicaStato();

    var input = document.querySelector('.omaggio__opt[data-opt="' + scelta + '"] .js-omaggio-testo');
    if (input) input.focus();
  });

  document.addEventListener('input', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('.js-omaggio-testo')) return;
    testi[t.dataset.opt] = t.value;
  });

  // Il click nel campo di testo non deve rimbalzare sulla label e cambiare scelta.
  document.addEventListener('click', function (evt) {
    if (evt.target && evt.target.matches && evt.target.matches('.js-omaggio-testo')) {
      evt.preventDefault();
      evt.target.focus();
    }
  });

  // Annoto quale albero sta partendo. Niente preventDefault: il form prosegue
  // normalmente e la confezione regalo resta libera di fare il suo lavoro.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('js-product-form')) return;
    if (!CFG.attivo || !conOmaggio()) return;

    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;

    inAttesa = {
      variantId: Number(id.value),
      titolo: CFG.prodotto,
      scelta: scelta,
      testo: (testi[scelta] || '').trim()
    };
  });

  async function aggiungiOmaggio() {
    if (!inAttesa) return false;
    var dati = inAttesa;
    inAttesa = null;

    var cart = await getCart();

    var gia = cart.items.filter(function (i) {
      return (i.properties || {})._omaggio === String(dati.variantId);
    })[0];
    if (gia) return false; // c'è già: ci pensa allinea() a sistemare la quantità

    var albero = cart.items.filter(function (i) {
      return i.variant_id === dati.variantId && !(i.properties || {})._omaggio;
    })[0];
    if (!albero) return false;

    var props = {
      _omaggio: String(dati.variantId),
      Per: dati.titolo || albero.product_title
    };

    if (dati.scelta === 'palline') {
      props['Modello palline'] = dati.testo || 'A nostra scelta';
    } else {
      props['Prodotto richiesto'] = dati.testo || 'Da concordare con il cliente';
    }

    await post(routes().add, {
      items: [{
        id: dati.scelta === 'palline' ? PALLINE : SCELTA,
        quantity: albero.quantity,
        properties: props
      }]
    });

    return true;
  }

  /* Allinea le quantità degli omaggi a quelle degli alberi, toglie gli omaggi
     rimasti orfani e gli eventuali doppioni. Gira su qualsiasi pagina. */
  async function allinea() {
    var cart = await getCart();

    var quantita = {};
    cart.items.forEach(function (i) {
      if ((i.properties || {})._omaggio) return;
      var k = String(i.variant_id);
      quantita[k] = (quantita[k] || 0) + i.quantity;
    });

    var daFare = [];
    var visti = {};

    cart.items.forEach(function (i) {
      var bersaglio = (i.properties || {})._omaggio;
      if (!bersaglio) return;

      var atteso = quantita[bersaglio] || 0;

      if (!atteso || visti[bersaglio]) {
        daFare.push({ id: i.key, quantity: 0 });
        return;
      }

      visti[bersaglio] = true;
      if (i.quantity !== atteso) daFare.push({ id: i.key, quantity: atteso });
    });

    if (!daFare.length) return false;
    for (var k = 0; k < daFare.length; k += 1) {
      await post(routes().change, daFare[k]);
    }
    return true;
  }

  async function sincronizza() {
    if (occupato) return;
    occupato = true;
    try {
      var aggiunto = await aggiungiOmaggio();
      var allineato = await allinea();
      if (aggiunto || allineato) await ridisegnaCarrello();
    } catch (e) {
      console.error('[omaggio]', e);
    } finally {
      occupato = false;
    }
  }

  document.addEventListener('on:cart:add', function () { setTimeout(sincronizza, 400); });
  document.addEventListener('on:line-item:change', function () { setTimeout(sincronizza, 400); });

  function avvio() {
    monta();
    if (document.querySelector('cart-items[data-empty="false"]')) sincronizza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvio);
  } else {
    avvio();
  }

  document.addEventListener('shopify:section:load', monta);

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(monta, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();